<template>
  <Layout>
    <Modal title="Agregar o editar licencia" class="licencia-modal" v-if="license_modal" @close="resetModal">
      <Grid width="300" gapped>
        <Input type="select" label="User" v-model="user_id" :value="user_id" :options="users" />

        <Input type="select" label="Sitio" :options="sites" v-model="sitename" :value="sitename" />
        <Input type="select" label="Sitio de gestion" :options="sites" v-model="sitename_managment"
          :value="sitename_managment" />
        <Input type="input" label="Duracion en dias" min="1" value="1" v-model="duration" :value="duration" />

        <Input type="select" label="Estado" :options="[
          { value: 'Activa', name: 'Activa' },
          { value: 'Finalizada', name: 'Finalizada' },
          { value: 'Bloqueada', name: 'Bloqueada' },
        ]" v-model="status" :value="status" />
      </Grid>
      <Input type="button" value="Guardar" class="mt-5" @action="submitLicense" />
    </Modal>
    <h1 noselect nopointer>Licencias</h1>
    <div flex flex-wrap gapped noselect nopointer>
      <p>Cantidad de licencias activas: </p>
      <p>Cantidad de licencias inactivas: </p>
      <p>Sitio con mas licencias: </p>
    </div>
    <div class="mt-3 mb-3" flex flex-wrap gapped>
      <Input type="button" value="Agregar" @action="() => { license_modal = true; selected_license = null }" />

      <Input type="select" :options="sites" v-model="sitename" />

      <Input type="button" value="Bloquear Todo" @action="updateAllLicenses('Bloqueada', 'Activa')"
        v-if="sitename?.length > 0" />

      <Input type="button" value="Desbloquear Todo" @action="updateAllLicenses('Activa', 'Bloqueada')"
        v-if="sitename?.length > 0" />

      <Input type="select" :options="users" v-model="user_id" :value="user_id" v-if="sitename?.length > 0" />
      <Input type="text" v-model="user_id" :value="user_id" v-if="sitename?.length > 0" />

    </div>
    <div class="table">
      <DataTable :value="info" selectionMode="single" dataKey="id" v-model:selection="selected_license">
        <Column field="id" header="ID" />
        <Column field="fecha_inicio" header="Fecha de Inicio" />
        <Column field="duracion_en_dias" header="Duracion en Dias" />
        <Column field="sitename" header="Sitio" />
        <Column field="site_name_managment" header="Sitio de Gestion" />
        <Column field="user_id" header="User ID" />
        <Column field="status" header="Estado" />
      </DataTable>
    </div>
  </Layout>
</template>

<script setup>
import Layout from "@/components/Layout/Layout.vue";
import { Input, Modal, Grid } from 'digitalpower'
import { onMounted, ref, watch } from "vue";
import { AuthService, DBService, post } from "@/services/apiReq";
import { DataTable, Column } from "primevue";
import { show } from "@/services/notification";
import { isAdmin } from "@/services/utils";
import { useUserStore } from "@/store/users";

const info = ref([]);
const sites = ref([]);

const license_modal = ref(false);

const selected_license = ref(null);
const user_id = ref(null);
const sitename = ref('');
const sitename_managment = ref('');
const duration = ref('');
const status = ref('');

const users = ref(null);

const userStore = useUserStore()

onMounted(async () => {
  await userStore.getUser()
  if (!isAdmin(userStore.user)) {
    location.href = "/user";
    return;
  }
  await fetch();
})

async function fetch() {
  const body = {
    table: 'licencias',
    page: 1,
    limit: 99999
  }

  if (sitename.value) {
    body.where = [
      { condition: { sitename: sitename.value }, strict: true },
    ]
  }

  if (user_id.value) {
    body.where.push({ condition: { user_id: { operator: 'LIKE', value: `%${user_id.value}%` } } });
    body.where.push({ condition: { site_name_managment: { operator: 'LIKE', value: `%${user_id.value}%` } } });
  }

  const response = await post('/get', body, DBService)
  info.value = response.data?.rows;

  const sites_fetch = await post('/list/db', {}, DBService);
  sites.value = sites_fetch.data;

  await checkLicenses();
}

async function fetchUsers() {
  users.value = [];
  const response = await post('/index', {
    schema: sitename.value,
    page: 1,
    limit: 99999,
  }, AuthService);

  users.value = response.data.users.map((user) => {
    return {
      ...user,
      name: `${user.id} - ${user.name} ${user.surname}`,
      value: user.id,
    }
  })
}

async function checkLicenses() {
  const lic = await post('/get', {
    table: 'licencias',
    page: 1,
    limit: 99999,
    where: [
      { condition: { status: 'Activa' } }
    ]
  }, DBService)
  let toRevoke = lic.data?.rows?.filter((license) => {
    const duration = license?.duracion_en_dias;
    const time = Date.now();
    const license_creation = new Date(license?.fecha_inicio);

    const expirationDate = new Date(license_creation);
    expirationDate.setDate(license_creation.getDate() + duration);

    if (expirationDate.getTime() < time) {
      return true;
    }
  })

  for (const license of toRevoke) {
    license.status = 'Finalizada';
    await post('/update', {
      table: 'licencias',
      where: {
        id: license?.id
      },
      data: license
    }, DBService)
  }
}

function resetModal() {
  selected_license.value = "";
  user_id.value = "";
  sitename.value = "";
  duration.value = "";
  status.value = "";

  selected_license.value = null;
  license_modal.value = false;
}

async function submitLicense() {
  if (!user_id.value || !sitename.value || !duration.value || !status.value) {
    show('Debe completar todos los campos')
    return;
  }

  try {
    const data = {
      fecha_inicio: new Date(),
      duracion_en_dias: duration.value,
      sitename: sitename.value,
      user_id: user_id.value,
      status: status.value,
      site_name_managment: sitename_managment.value,
    }
    if (selected_license.value !== null) {
      const response = await post('/update', {
        table: 'licencias',
        data: data,
        where: {
          id: selected_license.value?.id,
        }
      }, DBService);
    } else {
      const response = await post('/insert', {
        table: 'licencias',
        data: data
      }, DBService);
    }

    await fetch();
    resetModal()
  } catch (e) {
    show('Ha ocurrido un error al registra la licencia')
    console.log(e)
  }

  user_id.value = null;
  sitename.value = null;
}

async function updateAllLicenses(targetStatus, currentStatus) {
  if (!sitename.value) return;

  const targets = info.value.filter(l => l.status === currentStatus);

  if (targets.length === 0) {
    show(`No hay licencias ${currentStatus.toLowerCase()}s para actualizar.`);
    return;
  }

  try {
    for (const license of targets) {
      await post('/update', {
        table: 'licencias',
        where: { id: license.id },
        data: { ...license, status: targetStatus }
      }, DBService);
    }
    show(`Se han actualizado ${targets.length} licencias a estado ${targetStatus}.`);
    await fetch();
  } catch (e) {
    console.error(e);
    show('Error al actualizar licencias');
  }
}

watch(selected_license, (val) => {
  if (!val) return;

  user_id.value = Number(val.user_id);
  sitename.value = val.sitename;
  sitename_managment.value = val.site_name_managment;
  duration.value = val.duracion_en_dias;
  status.value = val.status;
  license_modal.value = true;
})
watch(sitename, (val, oldValue) => {
  if (!val || val === oldValue) return;
  fetch();
  fetchUsers()
}, {
  immediate: true,
  deep: true,
})
watch(user_id, (val, oldValue) => {
  if (val === oldValue) return;

  fetch()
}, {
  immediate: true,
  deep: true,
})
</script>

<style scoped lang="scss">
p {
  margin: 0;
}
</style>

<style>
td {
  text-align: center !important;
}

.p-datatable-column-header-content {
  text-align: center !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.licencia-modal {
  width: 90% !important;
  max-width: unset !important;
}
</style>